/**
 * Created by Christof Sander on 28.09.2016.
 */

module.exports = {

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();
			event.data.component.open()
		}
	},

	methods: {
		open: function(overrideDataJSON){
			const self = this;
			if(self.formMapping && self.formMapping.fieldConfig && self.formMapping.fieldConfig.isFilterField) return;

			if(overrideDataJSON !== undefined){
				self.model.dataJSON = overrideDataJSON
			}

			self.performAndStoreAction(
				'openModalInCharge',
				self.prepareAction(
					'openModal',
					undefined,
					{
						dataJSON: self.model.dataJSON
					},
					{
						source: {
							load: {
								componentData: {
									model: {
										title: 'JSON - Editor',
										buttons: [
											{ buttonType: 'submit', text: 'Übernehmen' },
											{ buttonType: 'cancel', text: 'Abbrechen' }
										]
									},
									actions: {
										loadContent: {
											source: {
												load: {
													resourceRegisterKey: 'dataJSON',
													componentData: {
														component: [
															'/',
															'base',
															'form',
															'fields',
															'json-editor'
														]
													}
												}
											}
										}
									}
								}
							}
						}
					}
				)
			);
		}
	},

	hooks: {
		async onDecision($element, options){
			const modal = (((this.actions.openModalInCharge || {}).source || {}).load || {}).component
			if(!modal){
				throw new ClientError('JSON_EDITOR_BUTTON_MISSING_MODAL')
			}

			if(options.decisionType !== 'submit') {
				return modal.hide()
			}

			let editor, parent
			modal.find('base_form_fields_json-editor', c => editor = c)
			this.parent(c => parent = c)

			if(!editor){
				throw new ClientError('JSON_EDITOR_BUTTON_MISSING_EDITOR')
			}

			// set modified json in model
			const value = this.model.dataJSON = editor.getEditorContent()

			// hide modal
			await modal.hide()

			if(parent){
				await parent.trigger('onChildChanged', {
					fieldCode:  this.model.fieldCode,
					value,
				})
			}
		},
	}
};
